// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3S6l6","content":"styles_content__9d7nJ","checkbox":"styles_checkbox__1WdD_","checkboxLabel":"styles_checkboxLabel__3cd7X"};